const SUMMARY_ID = "summary_id";
const ROW_TYPE = "row_type";
const UNDERLYING = "underlying";
const CALCULATION_DATE = "calculation_date";

function isSummaryLegLevelNode(node) {
  const rowData = node?.group ? node.aggData : node?.data;
  return rowData?.row_type === 1 && node?.level === 0;
}

export function isSummaryRowUnderlyingEdit(event) {
  if (event.colDef?.field !== UNDERLYING) return false;
  return event.node?.level === 0 && !isSummaryLegLevelNode(event.node);
}

export function resolvePricerSummaryId(rowData, node) {
  if (rowData?.[SUMMARY_ID] != null) {
    return rowData[SUMMARY_ID];
  }
  const leaf = node?.allLeafChildren?.[0]?.data;
  return leaf?.[SUMMARY_ID] ?? null;
}

export function buildSummaryUnderlyingUpdateBody(rowData, event, dateSelected) {
  return {
    [SUMMARY_ID]: resolvePricerSummaryId(rowData, event.node),
    [ROW_TYPE]: 0,
    [UNDERLYING]: +event.newValue,
    [CALCULATION_DATE]: dateSelected,
  };
}
